import { apiSlice } from "./apiSlice";

export const ScheduleSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getAllImplementationSchedule: builder.query({
            query: ({ type }) => ({
                url: `masterschedule?type=${type}`,
            }),
            providesTags: ["MasterSchedule"],
        }),
        getWorkflowHistoryImplementationSchedule: builder.query({
            query: (params) => {
                const { recordId, moduleName } = params;
                return {
                    url: `Workflow/history/${recordId}/${moduleName}`,
                };
            },
            keepUnusedDataFor: 0,
            providesTags: ["MasterSchedule"],
        }),
        getCriticalActivities: builder.query({
            query: ({ projectId, category }) => {
                const params = new URLSearchParams();
                params.set("projectId", projectId);
                params.set("category", category);
                return {
                    url: `/Schedule/activities/critical?${params.toString()}`,
                    method: "GET",
                };
            },
        }),
        getUpcomingCriticalActivities: builder.query({
            query: ({ projectId, category, startDate, endDate }) => {
                const params = new URLSearchParams();
                params.set("projectId", projectId);
                params.set("startDate", startDate);
                params.set("endDate", endDate);
                params.set("category", category)
                return {
                    url: `/Schedule/activities/critical?${params.toString()}`,
                    method: "GET",
                };
            },
        }),
        getMilestones: builder.query({
            query: (projectId) => `/Schedule/${projectId}/milestones`,
        }),

        getScheduleKpis: builder.query({
            query: ({ projectId, ...params }) => ({
                url: `Schedule/${projectId}/schedule-kpis`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            // providesTags: ["allActionTrackerComment"],
        }),
        getProjectSCurve: builder.query({
            query: ({ projectId, ...params }) => ({
                url: `Schedule/${projectId}/s-curve`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            // providesTags: ["allActionTrackerComment"],
        }),
        getWbsLevels: builder.query({
            query: ({ projectId, parentId }) => {
                const params = new URLSearchParams();
                params.set("projectId", projectId);
                if (parentId != null)
                    params.set("parentId", parentId);
                return {
                    url: `/Schedule/wbs-level?${params.toString()}`,
                    method: "GET",
                };
            },
        }),
        // getScheduleKpis: builder.query({
        //     query: (projectId) => `/Schedule/${projectId}/schedule-kpis`,
        // }),

        getWbsLevel: builder.query({
            query: ({ projectId, parentId }) => {
                const params = new URLSearchParams();
                params.set("projectId", projectId);

                // parentId OPTIONAL (root vs children)
                if (parentId) {
                    params.set("parentId", parentId);
                }

                return {
                    url: `/Schedule/wbs-level?${params.toString()}`,
                    method: "GET",
                };
            },
        }),

        getScheduleTracker: builder.query({
            query: ({
                projectId,
                parentId,
                activityId,
                startDateFrom,
                startDateTo,
                endDateFrom,
                endDateTo,
                showMonths
            }) => {

                const params = {
                    projectId,
                    ...(activityId ? { activityId } : { parentTaskId: parentId }),
                    ...(startDateFrom && { startDateFrom }),
                    ...(startDateTo && { startDateTo }),
                    ...(endDateFrom && { endDateFrom }),
                    ...(endDateTo && { endDateTo }),
                    ...({ showMonths: showMonths })
                };

                return {
                    url: `Schedule/${projectId}/report`,
                    method: 'GET',
                    params: params,
                };
            },
            keepUnusedDataFor: 60,
        }),
        getResourceSummary: builder.query({
            query: ({ projectId }) => ({
                url: `schedule/${projectId}/resource-summary`,
                method: "GET",
            }),
        }),

        getResourceActivities: builder.query({
            query: ({ projectId, resourceKey }) => ({
                url: `schedule/${projectId}/activities-by-resource/${resourceKey}`,
                method: "GET",
            }),
        }),

    }),

});

export const {
    useGetAllImplementationScheduleQuery,
    useGetWorkflowHistoryImplementationScheduleQuery,
    useGetCriticalActivitiesQuery,
    useGetMilestonesQuery,
    useGetUpcomingCriticalActivitiesQuery,
    useGetScheduleKpisQuery,
    useLazyGetScheduleKpisQuery,
    useGetWbsLevelQuery,
    useLazyGetWbsLevelQuery,
    useGetProjectSCurveQuery,
    useLazyGetProjectSCurveQuery,
    useGetWbsLevelsQuery,
    useLazyGetWbsLevelsQuery,
    useGetScheduleTrackerQuery,
    useLazyGetScheduleTrackerQuery,
    useGetResourceSummaryQuery,
    useLazyGetResourceActivitiesQuery,
} = ScheduleSlice;